// utils
import apiSlice from "src/utils/api-slice";
import { setURLParams } from "src/utils/url-query";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getRechargeHistory: "/web/transaction/record/page",
    achFeeConfig: "/web/transaction/ach_recharge/fee_config",
};

// ----------------------------------------------------------------------

const {
    useGetRechargeHistoryQuery,
    useGetAchFeeConfigQuery,
} = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getRechargeHistory: builder.query({
            keepUnusedDataFor: 5,
            providesTags: ["RechargeHistory"],
            query: ({ pay_status = "All", ...rest }) => {
                const params = setURLParams({ source_type: "Recharge", time_field: "created_at", ...rest });
                return `${API_ENDPOINTS.getRechargeHistory}${params}${params ? "&" : "?"}pay_status=${pay_status || "All"}`;
            },
            transformResponse: ({ data }) => ({
                records: data?.transaction_record_data ?? [],
                total: data?.total_count ?? 0
            })
        }),
        getAchFeeConfig: builder.query({
            keepUnusedDataFor: 0,
            query: () => API_ENDPOINTS.achFeeConfig,
            transformResponse: ({ data }) => ({
                fee_enabled: data?.fee_enabled ?? true,
                fee_amount: data?.fee_amount ?? 15
            })
        }),
    }),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    useGetRechargeHistoryQuery,
    useGetAchFeeConfigQuery,
};
